import { createContext, useContext } from 'react'
import { observable, action } from 'mobx'
import axios from 'axios'
import ConfigAPI from '../constant/ConfigAPI'

class FormReportStore {
    @observable isDisabledMapTool: boolean = false
    @action setIsDisabledMapTool = (isDisabledMapTool: boolean) => (this.isDisabledMapTool = isDisabledMapTool)

    @observable isOpenSurveyDetail: boolean = false
    @action setIsOpenSurveyDetail = (isOpenSurveyDetail: boolean) => (this.isOpenSurveyDetail = isOpenSurveyDetail)

    @observable surveyDetail: ReportSurveyDetailResponseType | null = null
    @action setSurveyDetail = (data: ReportSurveyDetailResponseType | null) => {
        this.surveyDetail = data
    }



    @action getSurveyDetail = async (dataId: number) => {

        let data: ReportSurveyDetailResponseType | null = null;
        const url = `${process.env.REACT_APP_API}/api/report/survey/${dataId}`
        const result = await axios.get(url, ConfigAPI)

        if (result.data){
            data = result.data as ReportSurveyDetailResponseType
        }
        return data
    }



    //ReportSurveyDetailResponseType <---- เปลี่ยนTypeรับของFeedbackDetail

    @observable isOpenDrawerFeedback: boolean = true
    @action setIsOpenDrawerFeedback = (open: boolean) => this.isOpenDrawerFeedback = open

    @observable isOpenFeedbackDetail: boolean = false
    @action setIsOpenFeedbackDetail = (isOpenFeedbackDetail: boolean) => (this.isOpenFeedbackDetail = isOpenFeedbackDetail)
    
    @observable feedbackDetail: ReportFeedbackDetailResponseType | null = null
    @action setFeedbackDetail = (data: ReportFeedbackDetailResponseType | null) => {
        this.feedbackDetail = data
    }

    @action getFeedbackDetail = async (dataId: number) => {

        let data: ReportFeedbackDetailResponseType | null = null;
        const url = `${process.env.REACT_APP_API}/api/report/feedback/${dataId}`
        const result = await axios.get(url, ConfigAPI)

        if (result.data){
            data = result.data as ReportFeedbackDetailResponseType
        }
        return data
    }
}

const formReportStoreContent = createContext(new FormReportStore())
const useFormReportStore = () => useContext(formReportStoreContent)

export default useFormReportStore